// Nombre de una mesa para mostrar. Con ambientes, el número se repite (Salón ·
// Mesa 3 y Terraza · Mesa 3), así que nunca se muestra el número interno de la
// mesa (`number`): el backend arma el nombre.
//   - Mesa: `place` ("Terraza · Mesa 3"; "Mesa 3" con un solo ambiente; o el
//     nombre de una mesa virtual, "Venta rápida 1").
//   - Pedido / venta / cancelación: `table_place`, la FOTO del momento en que se
//     hizo (mover o borrar la mesa después no cambia el historial).

// Lo que va después de la palabra "Mesa" (columnas y textos "Mesa X"):
// "3", "Terraza · 3" o el nombre de una mesa virtual.
export function getTableLabel(record) {
  const place = getTablePlace(record);
  if (place === "Mesa eliminada") return place;
  const label = place.startsWith("Mesa ") ? place.slice(5) : place.replace(" · Mesa ", " · ");
  // La mesa ya no existe (se borró después de la venta): se avisa.
  return record?.table_data === null && record?.table_number != null ? `${label} (eliminada)` : label;
}

// Número interno de la mesa, solo para agrupar u ordenar (nunca para mostrar).
export function getTableNumber(record) {
  return record.table_data ? record.table_data.number : record.table_number;
}

// Nombre completo del lugar, para títulos, avisos y celdas: "Mesa 3",
// "Terraza · Mesa 3" o "Venta rápida 1". Acepta una mesa o un pedido/venta.
export function getTablePlace(record) {
  if (!record) return "Mesa eliminada";
  if (record.table_place) return record.table_place;
  const table = record.table_data !== undefined ? record.table_data : record;
  if (table?.place) return table.place;
  if (table?.label) return table.label;
  if (table?.number != null) return `Mesa ${table.number}`;
  if (record.table_number != null) return `Mesa ${record.table_number}`;
  return "Mesa eliminada";
}

// Nombre sin el ambiente, para donde el ambiente ya se ve (pestañas de Pedidos,
// adhesivo del QR): "Mesa 3" o el nombre propio ("Barra").
export function getTableShortName(table) {
  const place = getTablePlace(table);
  const prefix = table?.area_name ? `${table.area_name} · ` : "";
  return prefix && place.startsWith(prefix) ? place.slice(prefix.length) : place;
}
